// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"246dfdb8","239":"47d0bf0d","453":"4b9514a1","732":"64aa0e2c"}[chunkId] + ".chunk.js";
};